import React, { useState, useEffect } from "react";

import {
  CCol,
  CRow,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CButton
} from "@coreui/react";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const StatisticsCurriculumFilter = props => {
  const activeRole = useSelector(state => state.general.active_roles);
  const token = useSelector(state => state.user.token);

  const [groups, setGroups] = useState([{ id: 0, name: "Carregando" }]);
  const [regions, setRegions] = useState([{ id: 0, name: "Carregando" }]);
  const [schools, setSchools] = useState([{ id: 0, name: "Carregando" }]);
  const [rooms, setRooms] = useState([{ id: 0, name: "Carregando" }]);
  const [periods, setPeriods] = useState([{ id: 0, name: "Carregando" }]);
  const [series, setSeries] = useState([{ id: 0, name: "Carregando" }]);
  const [disciplines, setDisciplines] = useState([
    { id: 0, name: "Carregando" }
  ]);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [periodId, setPeriodId] = useState(0);
  const [serieId, setSerieId] = useState(0);
  const [disciplineId, setDisciplineId] = useState(0);

  useEffect(() => {
    (async () => {
      let currentGroup = 0;
      let currentRegion = 0;
      let currentSchool = 0;
      let currentRoom = 0;
      let currentPeriod = 0;

      let currentGroups = [];
      let currentRegions = [];
      let currentSchools = [];
      let currentRooms = [];
      let currentPeriods = [];

      setGroups([{ id: 0, name: "Carregando" }]);
      setRegions([{ id: 0, name: "Carregando" }]);
      setSchools([{ id: 0, name: "Carregando" }]);
      setRooms([{ id: 0, name: "Carregando" }]);
      setPeriods([{ id: 0, name: "Carregando" }]);
      setSeries([{ id: 0, name: "Carregando" }]);
      setDisciplines([{ id: 0, name: "Carregando" }]);

      if (activeRole.group_id) {
        currentGroups = [
          { id: activeRole.group_id, name: activeRole.group_name }
        ];
        currentGroup = activeRole.group_id;

        const resPeriods = await axios
          .get(`${URL.api}education/period/list`, {
            params: { group_id: currentGroup },
            headers: { authorization: `Bearer ${token}` }
          })
          .catch();

        setPeriods([
          { id: 0, name: "Todas" },
          ...resPeriods.data.data.map(period => ({
            id: period.id,
            name: period.description
          }))
        ]);
        setPeriodId(0);
      } else {
        const res = await axios
          .get(`${URL.api}access/group/list`, {
            headers: { authorization: `Bearer ${token}` }
          })
          .catch();
        const allGroups = res.data.data.map(group => ({
          id: group.id,
          name: group.name
        }));

        currentGroups = allGroups;
        currentGroup = allGroups[0].id;

        setPeriods([{ id: 0, name: "Todas" }]);
        setPeriodId(0);
      }

      if (activeRole.region_id) {
        currentRegions = [
          { id: activeRole.region_id, name: activeRole.region_name }
        ];
        currentRegion = activeRole.region_id;
      } else if (currentGroup) {
        const res = await axios
          .get(`${URL.api}access/region/listRegionFilter/${currentGroup}`, {
            headers: { authorization: `Bearer ${token}` }
          })
          .catch();

        currentRegions = [
          { id: 0, name: "Todas" },
          ...res.data.data.map(region => ({ id: region.id, name: region.name }))
        ];
        currentRegion = 0;
      } else {
        currentRegions = [{ id: 0, name: "Todas" }];
        currentRegion = 0;
      }

      if (activeRole.school_id) {
        currentSchools = [
          { id: activeRole.school_id, name: activeRole.school_name }
        ];
        currentSchool = activeRole.school_id;
      } else if (currentRegion) {
        const res = await axios
          .get(
            `${URL.api}access/school/listSchoolFilter/${currentGroup}/${currentRegion}`,
            { headers: { authorization: `Bearer ${token}` } }
          )
          .catch();

        currentSchools = [
          { id: 0, name: "Todas" },
          ...res.data.data.map(school => ({ id: school.id, name: school.name }))
        ];
        currentSchool = 0;
      } else {
        currentSchools = [{ id: 0, name: "Todas" }];
        currentSchool = 0;
      }

      if (currentSchool) {
        const res = await axios
          .get(
            `${URL.api}community/room/list?group[]=${currentGroup}&region[]=${currentRegion}&school[]=${currentSchool}&class=true`,
            { headers: { authorization: `Bearer ${token}` } }
          )
          .catch();

        currentRooms = [
          { id: 0, name: "Todas" },
          ...res.data.data.map(room => ({ id: room.id, name: room.name }))
        ];
        currentRoom = 0;
      } else {
        currentRooms = [{ id: 0, name: "Todas" }];
        currentRoom = 0;
      }

      const resSeries = await axios
        .get(`${URL.api}classification/serie/list`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .catch();

      setSeries([
        { id: 0, name: "Todas" },
        ...resSeries.data.data.map(serie => ({
          id: serie.id,
          name: serie.name
        }))
      ]);
      setSerieId(0);

      const resDisciplines = await axios
        .get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .catch();

      setDisciplines([
        { id: 0, name: "Todas" },
        ...resDisciplines.data.data.map(discipline => ({
          id: discipline.id,
          name: discipline.name
        }))
      ]);
      setDisciplineId(0);

      const updateValues = values => {
        setGroups(values.groupsValue);
        setRegions(values.regionsValue);
        setSchools(values.schoolsValue);
        setRooms(values.roomsValue);

        setGroupId(values.groupValue);
        setRegionId(values.regionValue);
        setSchoolId(values.schoolValue);
        setRoomId(values.roomValue);
      };

      updateValues({
        groupsValue: currentGroups,
        regionsValue: currentRegions,
        schoolsValue: currentSchools,
        roomsValue: currentRooms,
        groupValue: currentGroup,
        regionValue: currentRegion,
        schoolValue: currentSchool,
        roomValue: currentRoom
      });
    })();
  }, []);

  const changeGroup = async newGroupId => {
    setGroupId(newGroupId);

    setRegions([{ id: 0, name: "Carregando" }]);
    setSchools([{ id: 0, name: "Carregando" }]);
    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(`${URL.api}access/region/listRegionFilter/${newGroupId}`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .catch();

    setRegions([
      { id: 0, name: "Todas" },
      ...res.data.data.map(region => ({ id: region.id, name: region.name }))
    ]);
    setRegionId(0);

    setSchools([{ id: 0, name: "Todas" }]);
    setSchoolId(0);

    setRooms([{ id: 0, name: "Todas" }]);
    setRoomId(0);

    const resPeriods = await axios
      .get(`${URL.api}education/period/list`, {
        params: { group_id: newGroupId },
        headers: { authorization: `Bearer ${token}` }
      })
      .catch();

    setPeriods([
      { id: 0, name: "Todas" },
      ...resPeriods.data.data.map(period => ({
        id: period.id,
        name: period.description
      }))
    ]);
    setPeriodId(0);
  };

  const changeRegion = async newRegionId => {
    setRegionId(newRegionId);

    setSchools([{ id: 0, name: "Carregando" }]);
    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(
        `${URL.api}access/school/listSchoolFilter/${groupId}/${newRegionId}`,
        { headers: { authorization: `Bearer ${token}` } }
      )
      .catch();

    setSchools([
      { id: 0, name: "Todas" },
      ...res.data.data.map(school => ({ id: school.id, name: school.name }))
    ]);
    setSchoolId(0);

    setRooms([{ id: 0, name: "Todas" }]);
    setRoomId(0);
  };

  const changeSchool = async newSchoolId => {
    setSchoolId(newSchoolId);

    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(
        `${URL.api}community/room/list?group[]=${groupId}&region[]=${regionId}&school[]=${newSchoolId}&class=true`,
        { headers: { authorization: `Bearer ${token}` } }
      )
      .catch();

    setRooms([
      { id: 0, name: "Todas" },
      ...res.data.data.map(room => ({ id: room.id, name: room.name }))
    ]);
    setRoomId(0);
  };

  const changeRoom = newRoomId => {
    setRoomId(newRoomId);
  };

  const changePeriod = newPeriodId => {
    setPeriodId(newPeriodId);
  };

  const changeSerie = newSerieId => {
    setSerieId(newSerieId);
  };

  const changeDiscipline = newDisciplineId => {
    setDisciplineId(newDisciplineId);
  };

  return (
    <>
      <CRow className="mb-4" style={{ width: "100%" }}>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Grupo</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-wrench"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={groupId}
              onChange={e => changeGroup(parseInt(e.target.value))}
              disabled={!!activeRole.group_id}
            >
              {groups.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Região</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-globe"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={regionId}
              onChange={e => changeRegion(parseInt(e.target.value))}
              disabled={!!activeRole.region_id}
            >
              {regions.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Escola</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-institution"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={schoolId}
              onChange={e => changeSchool(parseInt(e.target.value))}
              disabled={!!activeRole.school_id}
            >
              {schools.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Turma</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-graduation-cap"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={roomId}
              onChange={e => changeRoom(parseInt(e.target.value))}
            >
              {rooms.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
      </CRow>
      <CRow style={{ width: "100%" }}>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Período</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-wrench"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={periodId}
              onChange={e => changePeriod(parseInt(e.target.value))}
            >
              {periods.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Série</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-wrench"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={serieId}
              onChange={e => changeSerie(parseInt(e.target.value))}
            >
              {series.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">
              Componente curricular
            </Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-wrench"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={disciplineId}
              onChange={e => changeDiscipline(parseInt(e.target.value))}
            >
              {disciplines.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">&nbsp;</Label>
          </div>
          <div className="w-100 d-flex justify-content-end align-items-center">
            <CButton
              onClick={() =>
                props.onSearch({
                  group_id: groupId,
                  region_id: regionId,
                  school_id: schoolId,
                  room_id: roomId,
                  period_id: periodId,
                  serie_id: serieId,
                  discipline_id: disciplineId
                })
              }
              color="primary"
            >
              <i className="fa fa-search mr-2"></i>
              Procurar
            </CButton>
          </div>
        </CCol>
      </CRow>
    </>
  );
};

export default StatisticsCurriculumFilter;
